import styled from "@styled";

export const NotFoundPageWrapper = styled.div`
  margin: 40px 0;
`;
